export function sortStrArrContainingNumbers(strArr: string[]) {
  return strArr.sort(new Intl.Collator(undefined, { numeric: true }).compare)
}